module.exports = __webpack_public_path__ + "static/media/disability.4a453393.webp";